import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { SessionService } from '@parashift/shared/services';
import { AUTHORIZATION, Authorization, AuthorizationMethod } from '@parashift/shared/constants';

export const headerAuthorizationInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionService = inject(SessionService);

  const getToken = (authorization: Authorization): string => {
    switch(authorization.method) {
      case AuthorizationMethod.api_key:
        return authorization.token;
      case AuthorizationMethod.global_token:
        return authorization.token;
      default:
        return sessionService.session_token ?? sessionService.global_token;
    }
  }

  // Omit the header entirely when there's no token — sending `Bearer ` (empty) yields a 401 that
  // trips the error interceptor into a re-login loop. The bootstrap /me carries its one-time code
  // in the URL, so it doesn't need a bearer here.
  const token = getToken(req.context.get(AUTHORIZATION));
  const clonedReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(clonedReq);
};
